export { startSdinApplicationModule } from './start'

export type { SdinApplicationModuleStartingOptions } from './start'
